import { createContext } from 'react';
export var RouterContentContext = createContext(undefined);
export var RouterControllerContext = createContext(undefined);
export var RouterPendingContext = createContext(false);
export var RouterRequestContext = createContext(undefined);
export var UseRouterDefaultsContext = createContext({
    transitionTimeoutMs: Infinity,
});
